// queries/getProfileBanner.ts
import datoCMSClient from './datoCMSClient';
import { ProfileBanner } from '../types';

const GET_PROFILE_BANNER = `
 {
  profilebanner {
    backgroundImage {
      url
    }
    headline
    resumeLink {
      url
    }
    linkedinLink
    profileSummary
  }
}
`;

const FALLBACK_DATA: ProfileBanner = {
  backgroundImage: { url: "https://picsum.photos/1920/1080" }, // Placeholder image
  headline: "Mantavya Mahajan",
  resumeLink: { url: "/docs/resume.pdf" }, // Updated to match ContactMe routing
  linkedinLink: "https://www.linkedin.com/in/mantavya-mahajan-42972721b/",
  profileSummary: "Software Engineer (Backend) at Parafin | Spends team | Python, Scala | Previously Gen AI Technical Advisor at Scale AI"
};

export async function getProfileBanner(): Promise<ProfileBanner> {
  try {
    const data = await datoCMSClient.request<{ profilebanner: ProfileBanner }>(GET_PROFILE_BANNER);
    return data.profilebanner;
  } catch (error) {
    console.warn("Error fetching profile banner, using fallback data:", error);
    return FALLBACK_DATA;
  }
}